import { useQuery, gql } from '@apollo/client';

export const GET_ALL_SALARY_TYPES = gql`
  query getAllSalaryTypes {
    getAllSalaryTypes {
      _id
      name
      clientNumbers
      salaryTypeNumber
      clients {
        datevNumber
        _id
      }
    }
  }
`;

export const useGetAllSalaryTypes = () => {
  const { data, loading } = useQuery(GET_ALL_SALARY_TYPES, {
    fetchPolicy: 'cache-and-network',
  });

  return {
    healthInsurance: data?.getAllSalaryTypes || [],
    loading,
  };
};
